export { default as FullscreenExitIcon } from './FullscreenExitIcon';
